<template>
  <div class="community-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="社区名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入社区名称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="社区简称" prop="simpleName">
        <a-input v-model="form.simpleName" placeholder="请输入社区简称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="所在地" prop="area">
        <a-cascader v-model="form.area" :options="area.data" :fieldNames="area.fieldNames"  placeholder="请选择所在地"/>
      </a-form-model-item>
      <a-form-model-item label="物业团队" prop="team">
        <div>
          <a-button type="primary" @click="showModal">选择</a-button>
        </div>
        <div>
          <a-tag class="large" closable @close.prevent="delTeam(index)" v-for="(value, index) in form.team" :key="index">{{value.name}}</a-tag>
        </div>
      </a-form-model-item>
      <!-- <a-form-model-item label="可视对讲" prop="intercom">
        <a-radio-group v-model="form.intercom" :disabled="!!id">
          <a-radio :value="0">关</a-radio>
          <a-radio :value="1">开</a-radio>
        </a-radio-group>
      </a-form-model-item> -->
      <!-- <a-form-model-item label="道闸" prop="gate">
        <a-radio-group v-model="form.gate" :disabled="!!id">
          <a-radio :value="0">关</a-radio>
          <a-radio :value="1">开</a-radio>
        </a-radio-group>
      </a-form-model-item> -->
      <a-form-model-item label="物业电话" prop="phone">
        <a-input v-model="form.phone" placeholder="请输入物业电话" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" destroy-on-close width="60%" centered>
      <tree-select v-model="modal.team" :data="tree.data" :params="tree.params" multiple></tree-select>
    </a-modal>
  </div>
</template>

<script>
  import OrganizationService from '@/io/organization.js';
  import CommunityService from '@/io/community.js';
  import area from '@/io/area.json';
  import r from '@/assets/js/rule.js';

  export default {
    name: 'CommunityInfo',
    data() {
      return {
        id: this.$route.params.id,
        area: {
          data: area,
          fieldNames: {
            label: 'name',
            value: 'name',
            children: 'children'
          }
        },
        tree: {
          data: [],
          params: {
            children: 'children',
            title: 'name',
            key: '_id'
          }
        },
        modal: {
          title: '选择部门',
          show: false,
          team: []
        },
        form: {
          name: null,
          simpleName: null,
          area: null,
          team: [],
          intercom: 0,
          gate: 0,
          phone: null,
          status: 1
        },
        rules: {
          name: [
            {
              required: true,
              message: '请填写社区名称'
            }
          ],
          simpleName: [
            {
              validator: this.$debounce((rule, value, callback) => {
                if (value && !r.rule1(value)) {
                  callback(new Error('请输入英文字母'));
                } else if (value && value.length > 6) {
                  callback(new Error('请输入长度小于6的英文字母'));
                } else {
                  callback();
                }
              })
            }
          ],
          area: [
            {
              required: true,
              message: '请填写社区名称'
            }
          ],
          team: [
            {
              required: true,
              message: '请选择物业团队'
            }
          ],
          intercom: [
            {
              required: true,
              message: '请选择可视对讲'
            }
          ],
          gate: [
            {
              required: true,
              message: '请选择道闸'
            }
          ]
        }
      }
    },
    mounted () {
      this.initTreeData().then(() => {
        this.initPage();
      });
    },
    methods: {
      initPage() {
        if (this.id) {
          CommunityService.info(this.id).then(res => {
            this.form.name = res.name;
            this.form.simpleName = res.prefix;
            this.form.area = [res.province, res.city, res.area];
            this.formatTreeData(res.tissue_staff);
            this.form.team = res.tissue_staff;
            this.form.intercom = res.mj_switch;
            this.form.gate = res.gate_switch;
            this.form.phone = res.mobile;
            this.form.status = res.state;
          }).catch(err => {});
        }
      },
      delTeam(index) {
        this.form.team.splice(index, 1);
      },
      showModal() {
        this.modal.show = true;
        this.modal.team = this.$createNewVariable(this.form.team);
      },
      confirmModal() {
        this.modal.show = false;
        this.form.team = this.$createNewVariable(this.modal.team);
      },
      initTreeData() {
        return OrganizationService.companyStaffList().then(res => {
          this.formatTreeData(res);
          this.tree.data = res;
        }).catch(err => {});
      },
      formatTreeData(data) {
        this.$depthSearchTree(node => {
          let prefix = node.phone_number ? 's-' : 'd-';
          node._id = `${prefix}${node.id}`;
        }, data);
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            CommunityService.edit(
              this.id,
              this.form.name,
              this.form.simpleName + '',
              this.form.area[0],
              this.form.area[1],
              this.form.area[2],
              this.form.team.map(val => ({
                id: val.id,
                name: val[this.tree.params.title],
                phone_number: val.phone_number
              })),
              this.form.intercom,
              this.form.gate,
              this.form.phone,
              this.form.status
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          } else {
            CommunityService.add(
              this.form.name,
              this.form.simpleName,
              this.form.area[0],
              this.form.area[1],
              this.form.area[2],
              this.form.team.map(val => ({
                id: val.id,
                name: val[this.tree.params.title],
                phone_number: val.phone_number
              })),
              this.form.intercom,
              this.form.gate,
              this.form.phone,
              this.form.status
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          }
        });
      },
      cancel() {
        this.$router.push('/platform/community_manage');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>